import { useClientConfigProvider } from "@/app/config/client-config-provider";
import { useMixPanel } from "@/app/context/mixPanelContext";
import {
  SessionStorageConstants,
  LocalStorageUtils,
  useAppContext,
} from "@thriwe-2-0/thriwe-ui-utils";
import { usePathname } from "next/navigation";
import { useCallback, useEffect, useMemo, useState } from "react";
import AppRoutes from "@/app/constants/routes";
import FallbackImage from "@/app/component/FallbackImage";
import moment from "moment";
import AinaIntroModal from "./AinaIntroModal";

const routesEnabled = [
  AppRoutes.facility,
  AppRoutes.delayedBookingDetails,
  AppRoutes.dashboard,
];
export default function FloatingChatBotButton() {
  const [enableChatbot, setEnableChatbot] = useState<boolean>(false);
  const [showMessage, setShowMessage] = useState<boolean>(false);
  const [isClosed, setIsClosed] = useState<boolean>(false);
  const [showModal, setShowModal] = useState<boolean>(false);

  const { getImagePath, config } = useClientConfigProvider();
  const {
    instances: { apiRepository },
  } = useAppContext();
  const { trackEvent } = useMixPanel();
  const pathname = usePathname();

  const env = process.env.NEXT_PUBLIC_ENV;
  const stagUrl = process.env.NEXT_PUBLIC_CHATBOT_URL_STAG;
  const prodUrl = process.env.NEXT_PUBLIC_CHATBOT_URL_PROD;

  const baseUrl = useMemo(() => {
    return env === "PRODUCTION" ? prodUrl : stagUrl;
  }, [env, stagUrl, prodUrl]);

  const authToken = LocalStorageUtils.getFromLocalStorage(
    SessionStorageConstants.AUTH_TOKEN
  );
  const isModalShown =
    LocalStorageUtils.getFromLocalStorage("aina_modal_shown");

  const handleCloseTooltip = () => {
    setIsClosed(true);
    setShowMessage(false);
  };

  const finalUrl = useMemo(() => {
    if (!baseUrl) return "";
    return authToken ? `${baseUrl}?token=${authToken}` : baseUrl;
  }, [baseUrl, authToken]);

  const handleClick = useCallback(() => {
    if (!finalUrl) return;
    trackEvent?.("chatbot_opened");
    window.open(finalUrl, "_blank", "noopener,noreferrer");
  }, [finalUrl, trackEvent]);

  const isChatbotVisible =
    enableChatbot && !!finalUrl && routesEnabled.includes(pathname);

  useEffect(() => {
    if (!isChatbotVisible || isClosed) return;

    let hideTimeout: NodeJS.Timeout;

    const showTimeout = setTimeout(() => {
      setShowMessage(true);
      console.log({ moment: moment().toISOString() });

      hideTimeout = setTimeout(() => {
        setShowMessage(false);
        console.log({ moment: moment().toISOString() });
      }, 10000);
    }, 5000);

    return () => {
      clearTimeout(showTimeout);
      if (hideTimeout) clearTimeout(hideTimeout);
    };
  }, [isChatbotVisible, isClosed]);

  const checkChatbotEnabled = () => {
    apiRepository
      ?.checkChatbotEnabled({})
      .then((res: any) => {
        setEnableChatbot(res.data?.chatbot_enabled?.enabled);
        setShowModal(!isModalShown);
      })
      .catch(() => {
        setEnableChatbot(false);
      });
  };

  useEffect(() => {
    if (authToken) checkChatbotEnabled();
  }, [authToken]);

  if (!isChatbotVisible) {
    return null;
  }

  return (
    <div className="aina-wrapper">
      {showMessage && !isClosed && (
        <div className="aina-tooltip">
          <button className="tooltip-close" onClick={handleCloseTooltip}>
            ×
          </button>
          <span>I can help you redeem your benefits</span>
          <div className="tooltip-arrow" />
        </div>
      )}

      <AinaIntroModal
        isOpen={showModal}
        onClose={() => {
          setShowModal(false);
          LocalStorageUtils.saveToLocalStorage("aina_modal_shown", true);
        }}
        onPrimaryAction={handleClick}
      />
      <button className="aina-button" onClick={handleClick}>
        <FallbackImage
          src={getImagePath("chatbot_logo.png")}
          width={40}
          height={40}
          style={{ objectFit: "contain" }}
          fallbackSrc={""}
          alt={"aina"}
        />
      </button>
    </div>
  );
}
